import { render } from "./sub-category.vue?vue&type=template&id=e4609e8a"
import script from "./sub-category.vue?vue&type=script&lang=js"
export * from "./sub-category.vue?vue&type=script&lang=js"

import "./sub-category.vue?vue&type=style&index=0&id=e4609e8a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__